import { SubParticipant } from '@collector/sportsapi-types'

export function findSubParticipantWithStat(
  subParticipants: SubParticipant[],
  statId: number,
): SubParticipant | null {
  const subParticipant = subParticipants.find((sp) => {
    const stat = sp.stats?.find((s) => s.id === statId)

    return stat?.value === 1
  })

  return subParticipant ?? null
}
